






import { Component, Prop, Vue } from 'vue-property-decorator';
import * as def from '@/definitions'

@Component({
    components: {
    },
})

export default class TrimHandleTopLeft extends Vue 
{
    @Prop() private x! : number;
    @Prop() private y! : number;
    @Prop() private width! : number;
    @Prop() private height! : number;
    @Prop() private transform! : string;

    private get points()
    {
        var pts = "";

        var left = this.x - this.width / 2;
        var top = this.y - this.height / 2;
        pts += left + "," + top + " ";
        pts += left + "," + (top + this.height * 3) + " ";
        pts += (left + this.width) + "," + (top + this.height * 3) + " ";
        pts += (left + this.width) + "," + (top + this.height) + " ";
        pts += (left + this.width * 3) + "," + (top + this.height) + " ";
        pts += (left + this.width * 3) + "," + top;

        return pts;
    }

    private selectCursor(value)
    {
        this.$emit("selectCursor", value);
    }
}
